// Client mirror of auth/server/lib/nationalId.js (source of truth).
import { isValidEmso } from './kycValidators';

const JMBG_COUNTRIES = new Set(['SI', 'HR', 'BA', 'RS', 'ME', 'MK']);

const CF_ODD = {
  '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19,
  '9': 21, A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21,
  K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14, U: 16,
  V: 10, W: 22, X: 25, Y: 24, Z: 23
};
const CF_EVEN = {
  '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8,
  '9': 9, A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9, K: 10,
  L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19, U: 20, V: 21,
  W: 22, X: 23, Y: 24, Z: 25
};

function isValidCodiceFiscale(value) {
  const cf = String(value).toUpperCase().replace(/\s/g, '');
  if (!/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(cf)) return false;
  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const ch = cf[i];
    sum += (i % 2 === 0) ? CF_ODD[ch] : CF_EVEN[ch];
  }
  const control = String.fromCharCode(65 + (sum % 26));
  return control === cf[15];
}

const ES_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';
function isValidDniNie(value) {
  const s = String(value).toUpperCase().replace(/[\s-]/g, '');
  let m = /^(\d{8})([A-Z])$/.exec(s);
  let numStr;
  let letter;
  if (m) {
    numStr = m[1];
    letter = m[2];
  } else {
    m = /^([XYZ])(\d{7})([A-Z])$/.exec(s);
    if (!m) return false;
    const prefixVal = { X: '0', Y: '1', Z: '2' }[m[1]];
    numStr = prefixVal + m[2];
    letter = m[3];
  }
  return ES_LETTERS[parseInt(numStr, 10) % 23] === letter;
}

export function isValidNationalId(value, iso2) {
  if (!value) return false;
  const code = iso2 ? String(iso2).toUpperCase() : null;

  if (code && JMBG_COUNTRIES.has(code)) return isValidEmso(value);
  if (code === 'IT') return isValidCodiceFiscale(value);
  if (code === 'ES') return isValidDniNie(value);

  const v = String(value).toUpperCase().replace(/[\s.\-]/g, '');
  return /^[A-Z0-9]{4,32}$/.test(v);
}
